import React from "react";
import { Routes, Route } from "react-router-dom";

/// Css - Solo lo esencial para Trading
import "./index.css";

/// Layout - Solo lo esencial
import ScrollToTop from "./pages/ScrollToTop";
import NFTSelectionModal from "./components/NFTSelectionModal";
import PremiumUpgradeNotification from "./components/PremiumUpgradeNotification";
import LimitedAccessBanner from "./components/LimitedAccessBanner";
import { ProtectedRoute, ProtectionLevel } from "./components/ProtectedRoute";

/// Trading - Página principal
import TradingPage from "./pages/Trading";
import StakingPage from "./pages/Staking";

/// Prop Dashboard - Página del Prop Dashboard
import PropDashboard from "./pages/PropDashboard";

/// Operations - Página de operaciones de trading
import OperationsPage from "./pages/Operations";

/// NFT Registration - Página de registro de NFT
import NFTRegistration from "./pages/NFTRegistration";

/// NFT Flow - Pantallas del flujo de compra de NFT
import SelectNFTCollection from "./pages/NFT/SelectNFTCollection";
import ChooseCharacter from "./pages/NFT/ChooseCharacter";
import BuyPet from "./pages/NFT/BuyPet";
import PetConfirmation from "./pages/NFT/PetConfirmation";

/// Accounts - Sistema de compra de cuentas
import Accounts from "./pages/Accounts";

/// Auth - Páginas de autenticación
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const Markup = () => {
  return (
    <>
      <Routes>
        {/* Rutas públicas - sin restricciones */}
        <Route element={<ProtectedRoute level={ProtectionLevel.PUBLIC} />}>
          <Route path="/" element={<TradingPage />} />
          <Route path="/trading" element={<TradingPage />} />
          <Route path="/staking" element={<StakingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/page-register" element={<Registration />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Rutas que requieren wallet (permiten acceso limitado) */}
        <Route
          element={<ProtectedRoute level={ProtectionLevel.WALLET_REQUIRED} />}
        >
          <Route path="/register" element={<NFTRegistration />} />
          <Route path="/nft/register" element={<NFTRegistration />} />
          <Route
            path="/nft/select-nft-collection"
            element={<SelectNFTCollection />}
          />
          <Route path="/nft/choose-character" element={<ChooseCharacter />} />
          <Route path="/nft/buy-pet" element={<BuyPet />} />
          <Route path="/nft/pet-confirmation" element={<PetConfirmation />} />
        </Route>

        {/* Rutas que requieren acceso completo (NFT) */}
        <Route element={<ProtectedRoute level={ProtectionLevel.FULL_ACCESS} />}>
          <Route path="/prop-dashboard" element={<PropDashboard />} />
          <Route path="/propfirm" element={<PropDashboard />} />
          <Route path="/operations" element={<OperationsPage />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/purchase" element={<Accounts />} />
        </Route>

        {/* Catch all - redirect to trading */}
        <Route path="*" element={<TradingPage />} />
      </Routes>
      <ScrollToTop />
      <NFTSelectionModal />
      <PremiumUpgradeNotification />
      <LimitedAccessBanner />
    </>
  );
};

export default Markup;
